import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui/components/ui/card";
import { Label } from "@/ui/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/components/ui/select";
import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LocationSelectionProps {
  selectedLocationId: string;
  locations: any[] | undefined;
  isLoading: boolean;
  onLocationChange: (locationId: string) => void;
}

export const LocationSelection: React.FC<LocationSelectionProps> = ({
  selectedLocationId,
  locations,
  isLoading,
  onLocationChange,
}) => {
  const { t } = useTranslation("export");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          {t("locationSelection.title")}
        </CardTitle>
        <CardDescription>{t("locationSelection.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <Label htmlFor="location">{t("locationSelection.label")}</Label>
          <Select 
            value={selectedLocationId} 
            onValueChange={onLocationChange}
            disabled={isLoading}
          >
            <SelectTrigger>
              <SelectValue
                placeholder={
                  isLoading
                    ? t("locationSelection.loading")
                    : t("locationSelection.placeholder")
                }
              />
            </SelectTrigger>
            <SelectContent>
              {locations?.map((location) => (
                <SelectItem key={location.id} value={location.id.toString()}>
                  {location.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};
